export default __webpack_public_path__ + "static/media/tagline.f636c6a3.png";